module.exports = __webpack_public_path__ + "static/media/10.187dadb4.jpeg";